(() => {
  class Header {
    constructor() {
      this.desktopBp = window.matchMedia(`(min-width: ${window.breakpoints.desktop})`);
      this.els();
      this.listeners();
      this.toggleNavDetails();
    }

    els() {
      // this.mobileMenuSearch = document.querySelector('#mobileMenuSearchMenuQuery');
      // this.searchMenuToggleEls = document.querySelectorAll('[data-search-menu-toggle]');
      this.$mobileMenuAccordionToggles = document.querySelectorAll('[data-menu-accordion-toggle]');
      this.$nav = document.querySelector('#nav');
      this.$navClose = document.querySelector('#mobileMenuClose');
      this.$navDetails = document.querySelector('#navDetails');
      this.$navToggle = document.querySelector('#navSummary');
      this.$searchMenu = document.querySelector('#searchMenu');
      // this.$searchMenuQuery = document.querySelectorAll('[data-search-menu-query]');
      this.$submenuToggles = document.querySelectorAll('[data-menu-toggle]');
      this.$touchSubmenuToggles = document.querySelectorAll('[data-nav-menu-toggle]');
      this.$navItems = document.querySelectorAll('[data-nav-menu]');
      this.$hoverMenuItems = document.querySelectorAll('.nav__item[data-has-menu="true"]');
      this.hoverDelay = 300;
      this.hoverSwitchWindow = 100;
      this.hoverLeftAt = 0;
    }

    listeners() {
      window.subscribe(PUB_SUB_EVENTS.navClose, event => {
        this.close();
      });

      window.subscribe(PUB_SUB_EVENTS.navOpen, event => {
        this.open();
      });

      this.desktopBp.addEventListener('change', () => {
        this.toggleNavDetails();
      });

      this.$navClose.addEventListener('click', e => {
        this.navToggle(e);
      });

      this.$mobileMenuAccordionToggles.forEach(el => {
        el.addEventListener('click', e => {
          this.mobileMenuAccordionToggle(e);
        })
      });

      this.$navToggle.addEventListener('click', e => {
        this.navToggle(e);
      });

      this.$submenuToggles.forEach(el => {
        el.addEventListener('click', e => {
          this.submenuToggle(e);
        })
      });

      this.$touchSubmenuToggles.forEach(el => {
        el.addEventListener('click', e => {
          this.touchSubmenuToggle(e);
        })
      });

      this.$navItems.forEach(el => {
        el.addEventListener('mouseleave', () => {
          el.classList.remove('nav__item--force-closed');
        });
      });

      this.$hoverMenuItems.forEach(el => {
        el.addEventListener('mouseenter', () => {
          this.hoverOpen(el);
        });

        el.addEventListener('mouseleave', () => {
          this.hoverClose(el);
        });
      });

      document.addEventListener('onEsc', () => {
        const $menuActive = document.querySelector('.menu-active');

        if (this.desktopBp.matches) {
          // close touch/keyboard activated menu
          if ($menuActive) $menuActive.querySelector('[data-menu-toggle]').click();

          const $menuHover = document.querySelector('.nav__item--hover');
          if ($menuHover) {
            clearTimeout(this.hoverTimer);
            $menuHover.classList.remove('nav__item--hover');
          }
        } else {
          // close mobile menu
          if (document.documentElement.classList.contains('mobile-menu--active')) this.$navClose.click();
        }
      });
    }

    close(els) {
      els = typeof els !== 'undefined' ? els : document.querySelectorAll('body > *:not(.header-group), .header-group > *:not(.header), .header__logo, .nav__icons, #searchMenuToggle');
      this.$navDetails.removeAttribute('data-nav-inert');

      if (!this.desktopBp.matches) {
        this.$nav.setAttribute('inert', '');
        window.removeTrapFocus(this.$navToggle);
      }

      // untrap focus
      els.forEach(el => {
        el.removeAttribute('data-nav-inert');
        el.removeAttribute('inert');
      });

      lockScrollDisable();

      // close open menus
      document.querySelectorAll('.menu-active').forEach(el => {
        el.querySelector('[data-menu-toggle]').click();
      });

      requestAnimationFrame(() => {
        window.menuToggling = false;

        setTimeout(() => {
          document.documentElement.classList.remove('suggestions--active');
        }, 250);
      });
    }

    open(els) {
      // els = typeof els !== 'undefined' ? els : document.querySelectorAll('body > *:not(.header-group), .header-group > *:not(.header), .header__logo, .nav__icons, #searchMenuToggle');
      lockScrollEnable();

      if (!this.desktopBp.matches) {
        this.$nav.removeAttribute('inert');
        window.trapFocus(this.$nav, this.$navClose);
      }

      nav.scroll(0, 0);
      document.querySelectorAll('.nav__menu').forEach(el => el.scroll(0, 0));

      // trap focus
      if (els) {
        els.forEach(el => {
          el.setAttribute('data-nav-inert', true);
          el.setAttribute('inert', true);
        });
      }

      if (window.headerScrolled) document.documentElement.classList.add('header--scrolled');
      if (window.headerScrolledMobile) document.documentElement.classList.add('header--scrolled-mobile');
    }

    hoverOpen($item) {
      clearTimeout(this.hoverTimer);

      if (Date.now() - this.hoverLeftAt < this.hoverSwitchWindow) {
        $item.classList.add('nav__item--hover');
        return;
      }

      this.hoverTimer = setTimeout(() => {
        $item.classList.add('nav__item--hover');
      }, this.hoverDelay);
    }

    hoverClose($item) {
      clearTimeout(this.hoverTimer);

      if ($item.classList.contains('nav__item--hover')) this.hoverLeftAt = Date.now();
      $item.classList.remove('nav__item--hover');
    }

    // make desktop dropdowns work with touch screens
    touchSubmenuToggle(event) {
      if (this.desktopBp.matches && document.documentElement.classList.contains('touch')) {

        const $menuItem = event.target.closest('[data-nav-menu]');
        if (!$menuItem) return;

        const $openMenu = document.querySelector('[data-nav-menu].menu-active');

        if ($openMenu && $openMenu !== $menuItem) {
          $openMenu.classList.remove('menu-active');
          $openMenu.querySelector('[data-menu-toggle]').setAttribute('aria-expanded', false);
        }

        $menuItem.classList.toggle('menu-active');
        if ($menuItem.classList.contains('menu-active')) {
          event.preventDefault();
          event.stopPropagation();
        }
      }
    }

    // toggle mobile menu
    navToggle(event) {
      window.menuToggling = true;
      event.preventDefault();

      document.documentElement.classList.toggle('mobile-menu--active');

      const els = document.querySelectorAll('body > *:not(.header-group), .header-group > *:not(.header), .header__logo, .nav__icons, #searchMenuToggle');
      const isOpen = document.documentElement.classList.contains('mobile-menu--active');

      setTimeout(() => {
        if (isOpen) {
          this.open(els);
        } else {
          this.close(els);
        }
      }, !isOpen ? 250 : 0);
    };

    // mobile: expand/collapse a top-level item inline in place (accordion).
    // desktop: keyboard-focus toggle for the mega menu (traps focus like a modal).
    submenuToggle(event) {
      const $toggle = event.currentTarget;
      const $menuItem = $toggle.closest('[data-nav-menu]');
      const $openMenu = document.querySelector('[data-nav-menu].menu-active');

      if ($toggle.closest('.nav__footer')) $toggle.closest('.nav__footer').classList.toggle('has-menu-active');

      if ($openMenu && $openMenu !== $menuItem) {
        const $openToggle = $openMenu.querySelector('[data-menu-toggle]');
        $openToggle.setAttribute('aria-expanded', false);
        this.setToggleLabel($openToggle, false);
      }

      $menuItem.classList.toggle('menu-active');
      const isOpen = $menuItem.classList.contains('menu-active');
      $toggle.setAttribute('aria-expanded', isOpen);
      this.setToggleLabel($toggle, isOpen);

      if (!this.desktopBp.matches) return;

      nav.scroll(0, 0);
      document.querySelectorAll('.nav__menu').forEach(el => el.scroll(0, 0));

      nav.classList[isOpen ? 'add' : 'remove']('nav--submenu-open');

      const $submenuTrapEls = document.querySelectorAll('#navSummary, .nav > *:not(.menu-active):not(#mobileMenuClose):not(.nav__footer.has-menu-active):not(#mobileMenuSearchForm):not(search-menu), .nav__footer.has-menu-active > *:not(.menu-active)');

      if (isOpen) {
        $menuItem.classList.remove('nav__item--force-closed');

        // exclude sibling nav items from the a11y tree
        $submenuTrapEls.forEach(el => {
          el.setAttribute('data-subnav-inert', true);
          el.setAttribute('inert', true);
        });

        window.trapFocus($menuItem.querySelector('.nav__menu'), $toggle);
      } else {
        $menuItem.classList.add('nav__item--force-closed');

        document.querySelectorAll('[data-subnav-inert]').forEach(el => {
          el.removeAttribute('data-subnav-inert');
          el.removeAttribute('inert');
        });

        window.removeTrapFocus($toggle);
      }
    };

    setToggleLabel($toggle, isOpen) {
      $toggle.setAttribute('aria-label', `${isOpen ? 'Close' : 'Open'} ${$toggle.dataset.menuTitle} menu`);
    }

    mobileMenuAccordionToggle(event) {
      if (this.desktopBp.matches) return;

      const $toggle = event.target.closest('[data-menu-accordion-toggle]');
      if (!$toggle) return;

      event.preventDefault();

      const $menu = $toggle.closest('[data-menu-group]');
      if (!$menu) return;

      $menu.classList.toggle('active');
      const isOpen = $menu.classList.contains('active');

      if (isOpen) {
        $menu.setAttribute('open', '');
      } else {
        $menu.removeAttribute('open');
      }

      // a group can have more than one toggle (column header + per-link headline), keep them all in sync
      $menu.querySelectorAll(':scope > [data-menu-accordion-toggle]').forEach(el => el.setAttribute('aria-expanded', isOpen));
    }

    // keep <nav> a persistent navbar on desktop, a modal dialog on mobile
    toggleNavDetails() {
      if (this.desktopBp.matches) {
        this.$nav.removeAttribute('inert');
        this.$nav.removeAttribute('role');
        this.$nav.removeAttribute('aria-modal');

        // close mobile menu
        if (document.documentElement.classList.contains('mobile-menu--active')) {
          this.$navClose.click();
        }
      } else {
        this.$nav.setAttribute('role', 'dialog');
        this.$nav.setAttribute('aria-modal', 'true');

        if (!document.documentElement.classList.contains('mobile-menu--active')) {
          this.$nav.setAttribute('inert', '');
        }
      }
    }
  }

  new Header()
})();